import { action, observable } from "mobx";
import type { RecentProgress } from "models/results/Results";
import { resultsRepository } from "repositories";

interface ProductResultsStoreInterface {
  getRecentProgress: (productId: number) => void;
  setRecentProgress: (RecentProgress: RecentProgress) => void;
  recentProgress: RecentProgress | null;
}

const stateSetters = {
  setRecentProgress: action((recentProgress: RecentProgress) => {
    store.recentProgress = recentProgress;
  }),
};

const apiRequests = {
  getRecentProgress: action((productId: number) => {
    resultsRepository.getRecentProgress(productId).then((recentProgress: RecentProgress) => {
      store.setRecentProgress(recentProgress);
    });
  }),
};

const store = observable({
  ...stateSetters,
  ...apiRequests,
} as ProductResultsStoreInterface);

export const useProductResults = (): ProductResultsStoreInterface => store;
